import './App.css';
import Header from './Components/Header/Header';
import Activities from './Components/Activities/Activities';
import Questions from './Components/Questions/Questions';

function App() {
  return (
    <div className="App">
     <Header></Header>
     <Activities></Activities>
     <Questions></Questions>
    </div>
  );
}

export default App;
